import "./index.scss";
import React from "react";
import ReactGA from "react-ga4";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store, { persistor } from "./modules/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
const { REACT_APP_GA_TRACKING_ID } = process.env;

if (REACT_APP_GA_TRACKING_ID) {
  ReactGA.initialize(REACT_APP_GA_TRACKING_ID);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PersistGate loading={null} persistor={persistor}>
    {/* PersistGate 사용 */}
    <Provider store={store}>
      <App />
    </Provider>
  </PersistGate>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
